import { CardBody, Typography } from "@material-tailwind/react";
import EmptyState from "../../components/common/EmptyState";
import ClickBaseButton from "../../components/common/buttons/ClickBaseButton";
import { useNavigate } from "react-router-dom";
import { routerPaths } from "../../services/path";

function BoatEmptyState() {
  const navigator = useNavigate();

  return (
    <CardBody placeholder={undefined} className="justify-center items-center">
      <div className="justify-center flex h-20 ">
        <EmptyState />
      </div>
      <Typography placeholder={undefined}>No boats yet, create one</Typography>
      <ClickBaseButton onClick={() => navigator(routerPaths.createBoat)}>
        Add Boat
      </ClickBaseButton>
    </CardBody>
  );
}

export default BoatEmptyState;
